module.exports = __webpack_public_path__ + "static/media/a29.45e1d4cd.jpg";